define('social/facebook',['bwp/loader'], function(loader)
{
  if (document.getElementsByClassName('fb-like').length > 0) {
    var fb_root = document.createElement('div');

    fb_root.id = 'fb-root';
    document.body.insertBefore(fb_root, document.body.firstChild);

    loader.load_api('//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v2.8');
  }
});
